import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    establishmentToEditId: null,
    currentRequests: {},
    selectedEstablishmentsMoveEstablishment: {}
  },

  mutations: {
    CLEAN_ESTABLISHMENT_TO_EDIT (state) {
      state.establishmentToEditId = null
    },
    ESTABLISHMENT_TO_EDIT_SELECTED (state, establishmentId) {
      state.establishmentToEditId = establishmentId
    },
    SET_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT (state, selectedEstablishmentsMoveEstablishment) {
      state.selectedEstablishmentsMoveEstablishment = {
        establishmentOrigin: selectedEstablishmentsMoveEstablishment.establishmentOrigin,
        establishmentDestiny: selectedEstablishmentsMoveEstablishment.establishmentDestiny,
        deleteEstablishmentOrigin: selectedEstablishmentsMoveEstablishment.deleteEstablishmentOrigin
      }
    },
    CLEAN_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT (state) {
      state.selectedEstablishmentsMoveEstablishment = {}
    }
  },

  actions: {
    newEstablishment: ({ commit }, newEstablishment) => {
      return new Promise((resolve, reject) => {
        axios.post('/establishment/saveEstablishment', newEstablishment)
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    getEstablishments: ({ state, commit }, filter) => {
      state.currentRequests.getEstablishment = axios.CancelToken.source()
      return new Promise((resolve, reject) => {
        axios.post('/' + filter.url, filter, {
          cancelToken: state.currentRequests.getEstablishment.token
        })
        .then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getEstablishment: ({ commit }, establishmentId) => {
      return new Promise((resolve, reject) => {
        axios.get('/establishment/find/' + establishmentId)
          .then(response => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    setEstablishmentToEdit: ({ commit }, establishmentId) => {
      return new Promise((resolve, reject) => {
        commit('ESTABLISHMENT_TO_EDIT_SELECTED', establishmentId)
        resolve()
      })
    },

    cleanEstablishmentToEdit: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_ESTABLISHMENT_TO_EDIT')
        resolve()
      })
    },

    setSelectedEstablishmentsMoveEstablishment: ({ commit }, selectedEstablishmentsMoveEstablishment) => {
      return new Promise((resolve, reject) => {
        commit('SET_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT', selectedEstablishmentsMoveEstablishment)
        resolve()
      })
    },

    cleanSelectedEstablishmentsMoveEstablishment: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT')
        resolve()
      })
    },

    getEstablishmentGroups: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/establishmentGroups/list').then(response => {
          resolve(response.data.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getEstablishmentsToTreeGrid: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/establishment/listDetails', data)
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    loadEstablishmentAtt: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        axios.post(url).then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    moveEstablishment: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/establishment/moveEstablishment', data)
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    cancelEstablishmentsSearchRequests: ({ state }) => {
      for (const key in state.currentRequests) {
        if (state.currentRequests[key]) {
          if (typeof state.currentRequests[key].cancel === 'function') {
            state.currentRequests[key].cancel()
          }
          delete state.currentRequests[key]
        }
      }
    }
  },

  getters: {
    establishmentToEditId: state => state.establishmentToEditId,
    selectedEstablishmentsMoveEstablishment: state => state.selectedEstablishmentsMoveEstablishment
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/establishment.js